import jwtDecode from 'jwt-decode';

const SecondsForExpirationAction = 20;
const SecondsForAlertBeforeExpiration = 300;

let isAutoRefreshing = false;

function secondsLeftToTokenExpiration(apiToken) {
    const tokenPrefix = 'JWT ';
    const tokenWithoutPrefix = apiToken.startsWith(tokenPrefix) ? apiToken.substring(tokenPrefix.length) : apiToken;
    if (apiToken.startsWith(tokenPrefix) && tokenPrefix + tokenWithoutPrefix !== apiToken) {
        return 0;
    }
    const decodedToken = jwtDecode(tokenWithoutPrefix);
    const dateNowSeconds = Date.now() / 1000;
    return decodedToken.exp - dateNowSeconds;
}

function isTokenExpired(apiToken) {
    const secondsLeftToExpiration = secondsLeftToTokenExpiration(apiToken);
    return secondsLeftToExpiration <= SecondsForExpirationAction;
}

function isTokenExpiringSoon(apiToken) {
    const secondsLeftToExpiration = secondsLeftToTokenExpiration(apiToken);
    return secondsLeftToExpiration > 0 && secondsLeftToExpiration <= SecondsForAlertBeforeExpiration;
}

export function checkTokenExpiration(getTokenFromState, onTokenExpiration, showAlertAction?, autoRefreshAction?) {
    return (dispatch, getState) => {
        const state = getState();
        const apiToken = getTokenFromState(state);

        if (!apiToken) {
            return;
        }

        if (isTokenExpired(apiToken)) {
            dispatch(onTokenExpiration);
        } else if (isTokenExpiringSoon(apiToken)) {
            if (autoRefreshAction && !isAutoRefreshing) {
                isAutoRefreshing = true;
                dispatch(autoRefreshAction()).finally(() => {
                    isAutoRefreshing = false;
                    const currentToken = getTokenFromState(getState());
                    if (showAlertAction && currentToken && isTokenExpiringSoon(currentToken)) {
                        dispatch(showAlertAction);
                    }
                });
            } else if (showAlertAction && !autoRefreshAction) {
                dispatch(showAlertAction);
            }
        }
    };
}
